import React from 'react';

import ProfileMenu from '@app/src/common/components/profile-menu/ProfileMenu';
import HelpLink from '@app/src/common/components/header/HelpLink';

import './Header.scss';

const AppHeader = ({ children }: React.PropsWithChildren<{}>) => (
  <header className="app-header">
    {children}

    <HelpLink className="app-header__help" />

    <ProfileMenu className="app-header__menu" />
  </header>
);

export default AppHeader;
